import classNames from 'classnames';

export type FancyBorderProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {};

export default ({ children, className, ...props }: FancyBorderProps) => (
  <div className={classNames(className, '')} {...props}>
    <div className={`${className}__side ${className}__side--top`} />
    <div className={`${className}__side ${className}__side--right`} />
    <div className={`${className}__side ${className}__side--bottom`} />
    <div className={`${className}__side ${className}__side--left`} />
    <div className={`${className}__corner ${className}__corner--top-left`} />
    <div className={`${className}__corner ${className}__corner--top-right`} />
    <div className={`${className}__corner ${className}__corner--bottom-left`} />
    <div className={`${className}__corner ${className}__corner--bottom-right`} />
    {children}
  </div>
);
